import {
    CLOSE_SUBMENU,
    OPEN_SUBMENU,
    SET_ANIMATION_STATE,
    SET_SCROLL_POSITION,
} from "./mainNavbarActions";

export type MainNavbarState = {
    submenuOpen: boolean;
    loading: boolean;
    animationState: string;
    scrollPosition: {
        currentVertical: string;
        scrollY: number;
    };
};

const initialState = {
    submenuOpen: false,
    loading: false,
    animationState: "init",
    scrollPosition: {
        currentVertical: "",
        scrollY: 0,
    },
};

export const mainNavbar = (
    state: MainNavbarState = initialState,
    action: any,
): MainNavbarState => {
    switch (action.type) {
        case OPEN_SUBMENU:
            return {...state, submenuOpen: true};
        case CLOSE_SUBMENU:
            return {...state, submenuOpen: false};
        case SET_ANIMATION_STATE:
            return {...state, animationState: action.payload};
        case SET_SCROLL_POSITION:
            return {...state, scrollPosition: action.payload};
        default:
            return state;
    }
};

export default mainNavbar;
